import { toDictionaryById } from "../utils/common";
import { Field } from "../../entities/Metadata";
import { nameof } from "../../store/services/metadataService";
import { ApprovalType, IProcessStage, IProcessStageAttrs } from "../../entities/Subentities";
import { Validator } from "../../validation";
import { Process } from "../../store/process/common";
import DropdownInput from "../common/inputs/DropdownInput";
import { IInputProps } from "../common/interfaces/IInputProps";
import OptionEdit from "../field/SelectSettingsEdit/OptionEdit";
import EntityLayoutsDropdown from "../common/extensibleEntity/EntityLayoutsDropdown";
import { mapServerEntityType, PhaseCategory } from "../../entities/common";
import ApprovalForTransitions from "./ApprovalForTransitions";

export const rendersBuilder = (process: Process) => {
    if (!process.stagePhases?.length) {
        return {};
    }

    const stagePhaseByIdMap = toDictionaryById(process.stagePhases);

    return ({
        [nameof<IProcessStageAttrs>("Color")]: (inputProps: IInputProps, state: IProcessStage, field: Field, validator?: Validator): JSX.Element | null => {
            const stagePhase = stagePhaseByIdMap[state.attributes.Phase.id];
            return (
                <OptionEdit
                    index={0}
                    textFieldProps={{
                        readOnly: inputProps.readOnly,
                        disabled: inputProps.disabled,
                    }}
                    isUnique
                    hideRemoveColorButton
                    autoFocus
                    option={{
                        id: 'name-color',
                        name: state.attributes.Name ?? '',
                        color: inputProps.value ?? stagePhase?.color,
                    }}
                    onChange={_ => inputProps.onChanged?.(_.color, { [nameof<IProcessStageAttrs>("Name")]: _.name })}
                />
            );
        },
        [nameof<IProcessStageAttrs>("Phase")]: (inputProps: IInputProps, state: IProcessStage, field: Field, validator?: Validator): JSX.Element | null => {
            return (
                <DropdownInput
                    {...inputProps}
                    value={inputProps.value?.id ?? state.attributes.Phase.id}
                    onChanged={_ => {
                        const stagePhase = stagePhaseByIdMap[_];
                        const approvalForTransition = isSystemCategory(stagePhase.category) ? ApprovalType.None : state.attributes.ApprovalForTransition;
                        inputProps.onChanged?.(stagePhase, { [nameof<IProcessStageAttrs>("ApprovalForTransition")]: approvalForTransition })
                    }}
                    inputProps={{
                        options: process.stagePhases.map(_ => ({
                            key: _.id,
                            text: _.name,
                            color: _.color,
                        }))
                    }} />
            );
        },
        [nameof<IProcessStageAttrs>("EntityLayout")]: (inputProps: IInputProps, state: IProcessStage, field: Field, validator?: Validator): JSX.Element | null => {
            return (
                <EntityLayoutsDropdown
                    {...inputProps}
                    useEmptyValue
                    entityType={mapServerEntityType[process.attributes.EntityType]!}
                    layoutId={inputProps.value?.id}
                    onChanged={_ => inputProps.onChanged?.(_)}
                />
            );
        },
        [nameof<IProcessStageAttrs>('ApprovalForTransition')]: (inputProps: IInputProps, state: IProcessStage, field: Field): JSX.Element | null => {
            return <ApprovalForTransitions inputProps={inputProps} state={state} field={field} />
        }
    });
};

const SYSTEM_CATEGORIES: PhaseCategory[] = [
    PhaseCategory.Suspended,
    PhaseCategory.Canceled,
];

export const isSystemCategory = (category: PhaseCategory) => SYSTEM_CATEGORIES.includes(category);
